"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var result = {
    mac: false,
    ie: false,
    gecko: false,
    chrome: false,
    ios: false,
    android: false,
    webkit: false,
    safari: false
};
exports.browser = result;
if (typeof navigator !== 'undefined' && typeof document !== 'undefined') {
    var ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    var ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    var ie11Up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    result.mac = /Mac/.test(navigator.platform);
    var ie = (result.ie = !!(ieUpTo10 || ie11Up || ieEdge));
    result.gecko = !ie && /gecko\/(\d+)/i.test(navigator.userAgent);
    var chrome = !ie && /Chrome\/(\d+)/.exec(navigator.userAgent);
    result.chrome = !!chrome;
    result.ios =
        !ie &&
            /AppleWebKit/.test(navigator.userAgent) &&
            /Mobile\/\w+/.test(navigator.userAgent);
    result.android = /Android \d/.test(navigator.userAgent);
    result.webkit = !ie && 'WebkitAppearance' in document.documentElement.style;
    result.safari = /Apple Computer/.test(navigator.vendor);
}
//# sourceMappingURL=browser.js.map